import {Component, Output, EventEmitter, OnChanges, Input} from '@angular/core';
import { Rule } from '../services/capd.model';

@Component({
  selector: 'fd-message-editor',
  templateUrl: './fd-message-editor.component.html',
  inputs: ['rule', 'ruleClone', 'ruleChanged']
})

/**
 * The message editor for default (FD/HCC) environments.
 */
export class DefaultMessageEditorComponent implements OnChanges {

  @Output() changed: EventEmitter<any> = new EventEmitter();
  @Input() rule: Rule;
  @Input() ruleClone: Rule;
  @Input() ruleChanged: boolean;
  newChanged: boolean;

  single: string;
  second: string;

  /**
   * Whenever you change the rule, if the message editor is loaded, turn the options into a comma-separated list.
   *
   * @func ngOnChanges
   */
  ngOnChanges() {
    switch (this.rule.action.actionSubtype) {
      case 'Radio':
      case 'Dropdown':
        if (!!this.rule.action.groups) {this.single = this.rule.action.groups[1].options.join(','); }
        else {this.single = ''; }
        break;
      case 'DropdownStack':
        if (!!this.rule.action.groups) {
          this.single = this.rule.action.groups[1].options.join(',');
          this.second = this.rule.action.groups[2].options.join(',');
        }
        else{
          this.single = '';
          this.second = '';
        }
        break;
      case 'RadioInline':
      case 'DropdownInline':
        if (!!this.rule.action.groups) {
          this.single = this.rule.action.groups[1].options.join(',');
          this.second = this.rule.action.groups[3].options.join(',');
        }
        else{
          this.single = '';
          this.second = '';
        }
        break;
      default:
        this.single = '';
        this.second = '';
        break;
    }
  }

  /**
   * Sets the action type of the message depending on an ID number.
   *
   * @func setType
   * @param {number} typeId - the ID number of the type, to switch.
   */
  setType() {
    if (!this.rule.action.actionType.includes('Message')) {
      if (this.rule.action.actionType.includes('Instruction')) {
        this.rule.action.actionType = 'Message, Instruction';
      } else {
        this.rule.action.actionType = 'Message';
        this.rule.action.groups = new Array(4);
      }
      this.rule.action.actionSubtype = null;
      this.rule.action.messageText = this.getMessageText();
    }
  }

  private getMessageText() {
    const messageTextExists = (!!this.rule.action.messageText && this.rule.action.messageText !== '');
    const messageTextInGroupExists = (!!this.rule.action.groups && !!this.rule.action.groups[0]
        && !!this.rule.action.groups[0].messageText && this.rule.action.groups[0].messageText !== '');

    if (messageTextExists) {
      return this.rule.action.messageText;
    } else if (messageTextInGroupExists){
      return this.rule.action.groups[0].messageText;
    }
    else {
      return '';
    }
  }

  /**
   * Converts a list of comma-separated options into an array for display.
   *
   * @func convertToGroup
   * @param {string} data  - the unprocessed string.
   * @param {string} type  - the type of the particular action group.  If it's text, it needs no processing.
   * @param {number} index - the index of the group being edited.
   */
  convertToGroup(data: string, type: string, index: number) {
    if (type !== 'Text') {
      const dataConvert = data.split(',');
      dataConvert.forEach(val => val = val.trim());
      this.rule.action.groups[index] = { type, messageText: null, options: dataConvert };
    }
    else {
      this.rule.action.groups[index] = {type, messageText: data, options: null };
    }
  }

  /**
   * Function to check whether the rule has been edited.
   *
   * @func isEdited
   */
  isEdited() {
    this.newChanged = !(JSON.stringify(this.rule) === JSON.stringify(this.ruleClone));
    if (this.ruleChanged !== this.newChanged){
      this.changed.emit(this.newChanged);
    }
  }
}
